import { Injectable } from '@angular/core';
import { User, UserManager, UserManagerSettings } from 'oidc-client';

@Injectable()
export class AuthService {
  private manager: UserManager = new UserManager(getAuthClientSettings());
  private user: User = null;

  public startAuthentication(settings: UserManagerSettings): Promise<void> {
    return this.manager.signinRedirect();
  }

  public completeAuthentication(): Promise<void> {
    return this.manager.signinRedirectCallback().then(user => {
      this.user = user;
    });
  }

  public isLoggedIn(): boolean {
    return this.user != null && !this.user.expired;
  }

  public getClaims(): any {
    return this.user.profile;
  }

  public getAuthorizationHeaderValue(): string {
    return `${this.user.token_type} ${this.user.access_token}`;
  }

  constructor() {}
}

export function getAuthClientSettings(): UserManagerSettings {
  return {
    authority: 'https://accounts.autoloop.com',
    client_id: 'xrmcore_spa',
    redirect_uri: 'https://w184.car-research.com/XrmCore/auth-callback',
    post_logout_redirect_uri: 'https://w184.car-research.com/XrmCore',
    response_type: 'id_token token',
    scope: 'openid profile',
    filterProtocolClaims: true,
    loadUserInfo: true,
    automaticSilentRenew: true,
    silent_redirect_uri: 'https://w184.car-research.com/silent-refresh.html'
  };
}

export function getLinkClientSettings(): UserManagerSettings {
  return {
    authority: 'https://accounts.autoloop.com',
    client_id: 'xrmcore_spa',
    redirect_uri: 'https://w184.car-research.com/XrmCore/link-callback',
    response_type: 'id_token token',
    scope: 'openid profile',
    filterProtocolClaims: true,
    loadUserInfo: true
  };
}
